// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title-2qnSS","item":"index_item-1foIn"};